module.exports = __webpack_public_path__ + "static/img/11.8dbef7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/eng/11.png
// module id = XX6G
// module chunks = 0